<template>
    <div class="table">
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form"  v-loading="loading" :rules="rules" label-width="230px">
                <el-form-item   prop="deptId" label="学校：">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="onDeptChange" style="width:230px;">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-divider content-position="left">日常考评信息配置</el-divider>
                <el-form-item   prop="evaluateSwitch" label="启用日常考评："><el-checkbox v-model="form.evaluateSwitch"></el-checkbox></el-form-item>
                <el-form-item prop="organizeId" label="考评组织：">
                    <el-cascader  :disabled="!form.evaluateSwitch"
                        style="width: 230px"
                        :options="organizes"
                        v-model="form.organizeId"
                        :props="props"
                        collapse-tags
                        clearable></el-cascader>
                </el-form-item>

                <el-form-item prop="teacherIndicatorsLabel" label="设置教职加分指标：">
                    <el-input placeholder="请选择指标"  :disabled="!form.evaluateSwitch" :readonly="true" v-model="form.teacherIndicatorsLabel" class="input-with-select" style="width:230px;">
                        <el-button slot="append" icon="el-icon-search" @click="getEvaluate(teacherIndicatorsName)"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item prop="studentIndicatorsLabel" label="设置教职扣分指标：">
                    <el-input placeholder="请选择指标"  :disabled="!form.evaluateSwitch" :readonly="true" v-model="form.studentIndicatorsLabel" class="input-with-select" style="width:230px;">
                        <el-button slot="append" icon="el-icon-search" @click="getEvaluate(studentIndicatorsName)"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item label="考评日期范围：">
                   每学年的上学期是
                   <el-date-picker style="width:140px;" 
                        :disabled="!form.evaluateSwitch"
                        v-model="form.lastStartDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>到明年
                    <el-date-picker style="width:140px;"
                        :disabled="!form.evaluateSwitch"
                        v-model="form.lastEndDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">>
                    </el-date-picker>
                    ，
                    下学期是明年的
                    <el-date-picker style="width:140px;"
                        v-model="form.nextStartDate"
                        :disabled="!form.evaluateSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>
                    到
                    <el-date-picker style="width:140px;"
                        v-model="form.nextEndDate"
                        :disabled="!form.evaluateSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">>
                    </el-date-picker>
                </el-form-item>

                <el-form-item prop="calculateTime" label="计算考评和推送教职时间：">
                    <el-time-select style="width:140px;"
                        v-model="form.calculateTime"
                        :disabled="!form.evaluateSwitch"
                        :readonly="setReadonly"
                        :picker-options="{
                            start: '01:00',
                            step: '00:15',
                            end: '23:45'
                        }"
                        placeholder="选择时间">
                    </el-time-select>
                </el-form-item>
                
                <el-divider content-position="left">奖惩规则配置</el-divider>
                <el-form-item label="教职评价规则：">
                    <el-select v-model="form.teacherCycle" :disabled="!form.evaluateSwitch" placeholder="请选择" clearable style="width:100px;">
                        <el-option
                            v-for="item in cycleType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>&nbsp;所有老师就在基础分上加&nbsp;<el-input v-model="form.tScore"  :disabled="!form.evaluateSwitch" type="number" style="width:120px;" placeholder="请输入分数"></el-input>&nbsp;分，但是扣分的就不加分。
                </el-form-item>

                <el-form-item label="学生评价规则1：">
                    <el-select v-model="form.studentCycle" :disabled="!form.evaluateSwitch" placeholder="请选择" clearable style="width:100px;">
                        <el-option
                            v-for="item in cycleType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>&nbsp;低于评价&nbsp;<el-input v-model="form.sCount1"  :disabled="!form.evaluateSwitch" type="number" style="width:120px;" placeholder="请输入整数"></el-input>&nbsp;个
                    &nbsp;<el-select v-model="form.numberType1" placeholder="请选择" clearable style="width:100px;">
                        <el-option
                            :disabled="!form.evaluateSwitch"
                            v-for="item in peopleType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    &nbsp;的老师扣&nbsp;<el-input v-model="form.sScore1" :disabled="!form.evaluateSwitch" type="number" style="width:160px;" placeholder="扣分<0"></el-input>&nbsp;分。
                </el-form-item>
                <el-form-item label="学生评价规则2：">
                    低于评价&nbsp;<el-input v-model="form.sCount2" type="number" :disabled="!form.evaluateSwitch" style="width:120px;" placeholder="请输入整数"></el-input>&nbsp;个
                    &nbsp;<el-select v-model="form.numberType2" placeholder="请选择" :disabled="!form.evaluateSwitch" clearable style="width:100px;">
                        <el-option
                            :disabled="!form.evaluateSwitch"
                            v-for="item in peopleType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    &nbsp;的老师扣&nbsp;<el-input v-model="form.sScore2" type="number" :disabled="!form.evaluateSwitch" style="width:160px;" placeholder="扣分<0"></el-input>&nbsp;分。
                </el-form-item>
                <el-form-item label="学生评价规则说明：">
                    规则1满足情况下，规则2不生效；规则1不满足情况下，规则2符合条件就生效。
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="danger" @click="clearConfig()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
        </div>
        <!-- 教职评价、学生评价指标弹出框 -->
        <div v-if="indicatorsDefineVisable">
            <indicatorsDefine ref="indicatorsDefine"></indicatorsDefine>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import indicatorsDefine from './indicatorsDefine.vue';
    import { MessageBox } from 'element-ui';

    export default {
        data(){
            return{
                loading: false,
                setReadonly: false,
                props: { checkStrictly: true},
                indicatorsDefineVisable: false,

                teacherIndicatorsName:"教职评价",
                studentIndicatorsName:"学生评价",
                form:{
                    evaluateSwitch:false,
                    deptId:"", // 学校ID
                    organizeId:"", // 组织ID
                    teacherIndicatorsId:"", //教职评价指标ID
                    teacherIndicatorsLabel:"", //教职评价指标Label
                    studentIndicatorsId:"", //学生评价指标ID
                    studentIndicatorsLabel:"", //学生评价指标Label
                    lastStartDate:"", // 上学期开始日期
                    lastEndDate:"", // 上学期结束日期
                    nextStartDate:"", // 下学期开始日期
                    nextEndDate:"", // 下学期结束日期
                    calculateTime:"", // 每日计算考评时间
                    
                    teacherCycle:"", // 规则1-周期类型
                    tScore:"", // 规则1-加分
                    studentCycle:"", // 学生周期类型
                    sScore1:"", // 规则2-扣分
                    sScore2:"", // 规则2-扣分
                    sCount1:"",
                    sCount2:"",
                    numberType1:"",
                    numberType2:"",
                },
                depts:[],
                organizes:[],
                cycleType:[
                    {
                        value: 1,
                        label: '每工作日'
                    },
                    {
                        value: 2,
                        label: '每周'
                    },{
                        value: 3,
                        label: '每月'
                    },
                ],
                peopleType:[
                    {
                        value: 1,
                        label: '学生人数'
                    },{
                        value: 2,
                        label: '评价数量'
                    }
                ],
                rules: {
                    deptId: [
                        { required: true, message: '请选择学校', trigger: 'blur' }
                    ],
                    organizeId: [
                        { required: true, message: '请选择考评组织', trigger: 'blur' }
                    ],
                    teacherIndicatorsLabel:[
                        {required: true, message: '请设置教职评价指标', trigger: 'blur' }
                    ],
                    studentIndicatorsLabel:[
                        {required: true, message: '请设置学生评价指标', trigger: 'blur' }
                    ],
                    calculateTime: [
                        { required: true, message: '请选择计算考评和推送教职时间', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
            this.getDeptData();
        },
        components: {
            indicatorsDefine
        },
        methods:{
            // 获取部门管理
            getDeptData(){
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                        this.getOrganizes();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.getData();
                this.getOrganizes();
            },
            // 根据条件获取当前界面数据
            getData(){
                this.clear(); // 清空数据
                this.form.evaluateSwitch = false
                let url  = this.teacherDailyEvaluateSetListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 渲染清空数据
                        let resultData=res.data
                        console.log('resultData', resultData)
                        // 渲染有数据值
                        for(let i=0;i<resultData.length;i++){
                            let obj=resultData[i]

                            // 键Key jc_rule_key-奖惩规则配置）
                            if(obj.setKey == 'evaluate_switch_key'){ // 启用日常考评
                                if(obj.setVal == 1){
                                    this.form.evaluateSwitch = true
                                }else{
                                    this.form.evaluateSwitch = false
                                }
                            }else if(obj.setKey == 'evaluate_dept_key'){ // 考评组织
                                this.form.organizeId = obj.setVal
                                console.log("赋值organizeId：", this.form.organizeId)
                            }else if(obj.setKey == 'teacher_evaluateIndicators_key'){ // 教职评价指标
                                let selectEvaluateIndicators = JSON.parse(obj.setVal)
                                this.form.teacherIndicatorsId = selectEvaluateIndicators.key
                                this.form.teacherIndicatorsLabel = selectEvaluateIndicators.label
                            }else if(obj.setKey == 'student_evaluateIndicators_key'){ // 学生评价指标
                                let selectEvaluateIndicators = JSON.parse(obj.setVal)
                                this.form.studentIndicatorsId = selectEvaluateIndicators.key
                                this.form.studentIndicatorsLabel = selectEvaluateIndicators.label
                            }else if(obj.setKey == 'evaluate_dateRange_key'){ // 考评日期范围
                                let dateRange = JSON.parse(obj.setVal)
                                this.form.lastStartDate = dateRange.lastStartDate
                                this.form.lastEndDate = dateRange.lastEndDate
                                this.form.nextStartDate = dateRange.nextStartDate
                                this.form.nextEndDate = dateRange.nextEndDate
                            }else if(obj.setKey == 'calculate_time_key'){ // 每日计算考评和推送教职时间
                                this.form.calculateTime = obj.setVal
                            }else if(obj.setKey == 'jc_rule_key'){ // 奖惩规则配置
                                let resultObj=JSON.parse(obj.setVal)
                                this.form.tScore=resultObj.jiaf
                                this.form.sScore1=resultObj.jianf1
                                this.form.sScore2=resultObj.jianf2

                                this.form.teacherCycle = resultObj.teacherCycle
                                this.form.tScore = resultObj.tScore

                                this.form.studentCycle = resultObj.studentCycle
                                this.form.sCount1 = resultObj.sCount1
                                this.form.numberType1 = resultObj.numberType1
                                this.form.sScore1 = resultObj.sScore1
                                
                                this.form.sCount2 = resultObj.sCount2
                                this.form.numberType2 = resultObj.numberType2
                                this.form.sScore2 = resultObj.sScore2
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            //获取考评组织列表
            getOrganizes(){
                let url = this.getDeptCascaderUrl
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url, data).then(
                    (res) => {
                        if (res.status == 200) {
                            this.organizes = res.data.selects
                            console.log('organizeId前：', this.form.organizeId)
                            this.form.organizeId = this.getName(this.form.organizeId,this.organizes)
                            console.log('organizeId后：', this.form.organizeId)
                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                    },(err) => {
                        console.log(err);
                    }
                );
            },
            // 获取对应的指标
            getEvaluate(indicatorsName){
                console.log('indicatorsName',indicatorsName)
                this.indicatorsDefineVisable=true
                this.$nextTick(() => { 
                    this.$refs['indicatorsDefine'].init(this.form.deptId, indicatorsName)
                })
            },
            setEvaluate(key, label, indicatorsName){
                if(this.teacherIndicatorsName == indicatorsName){
                    this.form.teacherIndicatorsId = key //教职评价指标ID
                    this.form.teacherIndicatorsLabel = label //教职评价指标Label
                }else if(this.studentIndicatorsName == indicatorsName){
                    this.form.studentIndicatorsId = key //学生评价指标ID
                    this.form.studentIndicatorsLabel = label //学生评价指标Label
                }
            },
            // 清空配置
            clear(){
                this.form.evaluateSwitch = false
                this.form.organizeId="" // 组织ID
                this.form.teacherIndicatorsId="" //教职评价指标ID
                this.form.teacherIndicatorsLabel="" //教职评价指标Label
                this.form.studentIndicatorsId="" //学生评价指标ID
                this.form.studentIndicatorsLabel="" //学生评价指标Label
                this.form.lastStartDate="" // 上学期开始日期
                this.form.lastEndDate="" // 上学期结束日期
                this.form.nextStartDate="" // 下学期开始日期
                this.form.nextEndDate="" // 下学期结束日期
                this.form.calculateTime="" // 每日计算考评时间

                this.form.teacherCycle = "", // 规则1-周期类型
                this.form.tScore = "" // 规则1-加分
                this.form.studentCycle = "" // 学生周期类型
                this.form.sScore1 = "" // 规则2-扣分
                this.form.sScore2 = "" // 规则2-扣分
                this.form.sCount1 = ""
                this.form.sCount2 = ""
                this.form.numberType1 = ""
                this.form.numberType2 = ""
            },
            // 保存
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 考评日期范围不为空验证
                        if(this.$util.isEmpty(this.form.lastStartDate)){
                            this.$commonFn.showTip('上学期开始日期不为空',3)
                            return
                        }else if(this.$util.isEmpty(this.form.lastEndDate)){
                            this.$commonFn.showTip('上学期结束日期不为空',3)
                            return
                        }else if(this.$util.isEmpty(this.form.nextStartDate)){
                            this.$commonFn.showTip('下学期开始日期不为空',3)
                            return
                        }else if(this.$util.isEmpty(this.form.nextEndDate)){
                            this.$commonFn.showTip('下学期结束日期不为空',3)
                            return
                        }
                        // 奖惩规则配置不为空验证
                        if(this.$util.isEmpty(this.form.tScore) || this.$util.isEmpty(this.form.teacherCycle)){
                            this.$commonFn.showTip('教职评价规则-配置项不允许为空',3)
                            return
                        }else if( this.$util.isEmpty(this.form.studentCycle) || this.$util.isEmpty(this.form.sCount1)
                                || this.$util.isEmpty(this.form.numberType1) || this.$util.isEmpty(this.form.sScore1)
                                || this.$util.isEmpty(this.form.numberType2) || this.$util.isEmpty(this.form.sCount2)
                                || this.$util.isEmpty(this.form.sScore2) ){
                            this.$commonFn.showTip('学生评价规则-配置项不允许为空',3)
                            return
                        }

                        let obj={};
                        // 启用日常考评
                        obj['evaluate_switch_key'] = this.form.evaluateSwitch?1:0
                        // 考评组织
                        let organizeId = this.form.organizeId
                        obj['evaluate_dept_key']=organizeId[organizeId.length-1]
                        // 教职评价指标
                        let teacherIndicators = {}
                        teacherIndicators.key = this.form.teacherIndicatorsId
                        teacherIndicators.label = this.form.teacherIndicatorsLabel
                        obj['teacher_evaluateIndicators_key']=JSON.stringify(teacherIndicators)
                        // 学生评价指标
                        let studentIndicators = {}
                        studentIndicators.key = this.form.studentIndicatorsId
                        studentIndicators.label = this.form.studentIndicatorsLabel
                        obj['student_evaluateIndicators_key']=JSON.stringify(studentIndicators)
                        // 考评日期范围
                        let dateRange = {}
                        dateRange.lastStartDate = this.form.lastStartDate
                        dateRange.lastEndDate = this.form.lastEndDate
                        dateRange.nextStartDate = this.form.nextStartDate
                        dateRange.nextEndDate = this.form.nextEndDate
                        obj['evaluate_dateRange_key']=JSON.stringify(dateRange)
                        // 每日计算考评和推送教职时间
                        obj['calculate_time_key'] = this.form.calculateTime
                        // 奖惩规则配置
                        let resultObj={};
                        resultObj['teacherCycle'] = this.form.teacherCycle
                        resultObj['tScore'] = parseInt(this.form.tScore, 10)

                        resultObj['studentCycle'] = this.form.studentCycle
                        resultObj['sCount1'] = parseInt(this.form.sCount1, 10)
                        resultObj['numberType1'] = parseInt(this.form.numberType1, 10)
                        resultObj['sScore1'] = parseInt(this.form.sScore1, 10)

                        resultObj['sCount2'] = parseInt(this.form.sCount2, 10)
                        resultObj['numberType2'] = parseInt(this.form.numberType2, 10)
                        resultObj['sScore2'] = parseInt(this.form.sScore2, 10)
                        obj['jc_rule_key'] = JSON.stringify(resultObj)

                        console.log(JSON.stringify(obj))
                        // return;
                        this.loading=true; // 正在保存中
                        let data = {
                            'deptId':this.form.deptId,
                            'data':JSON.stringify(obj)
                        };
                        this.apiPost(this.teacherDailyEvaluateSetSaveUrl, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1)
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                            this.loading=false;
                        }, (err) => {
                            this.$commonFn.showTip(err,3)
                            this.loading=false;
                        });
                    }
                });
            },
            // 考评组织
            getName(setVal,data){
                if(this.$util.isNotEmpty(data)){
                   let valArr = setVal.split(",");
                   var arr = new Array();
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                   return arr[0];
                }
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            },
            // 清空配置
            clearConfig(){
                 MessageBox.confirm('此操作将永久清空配置数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
                    let url = this.teacherDailyEvaluateSetDelUrl;
                    let data = {
                        deptId:this.form.deptId
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        this.$commonFn.showTip(err,3);
                    });
                }).catch(() => {
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/teacherEvaluateSet/list.vue